import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import Button from "../shared/Button";
import { handleActiveSelect } from "../../features/layout/layoutSlice";
import { useScrollLock } from "../../hooks/useScrollLock";
import { closeAllModal, showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 650px;
    height: 200px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 30px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;


    .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
        p{
            font-size: var(--font-size-xl);
            font-weight: var(--font-weight-lg);
            color:var(--color-dark);
        }
        .btn{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
  }
`;

const FreightInfoModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleDelete = () => {
    dispatch(closeAllModal(null))
  }


  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
            <p>Navlun Fiyatından daha düşük fiyat girdiniz. Emin misiniz?</p>
            <div className="btn">
                <Button handleClick={handleDelete} color={"#F4F4F4"} background={"#E85446"} width="200px" radius={"10px"} text={"Kapat"} fontSize="14px"/>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default FreightInfoModal;
